/**
 * http
 *
 * @author Shigq
 * @date 2021/11/15 14:50
 */
import { http, vab, cookieUtils } from '@libs/utils'
import { httpCode } from '@/config/net.config'
import { tokenName } from '@/config/setting.config'
import router from '@/router'
import { useI18n } from '@/plugins/i18n'
const { t, isLocal } = useI18n()

function parseRspBody(response) {
  const { config } = response
  const rsp = {
    code: '',
    message: '',
    rspData: '',
    config: config
  }

  const {
    data: {
      header: {
        code,
        message
      },
      ...rspData
    }
  } = response

  rsp.code = code
  rsp.message = message
  rsp.rspData = rspData

  return rsp
}

/**
 * handle error code
 *
 * @description 处理code异常
 * @param {*} code
 * @param {*} msg
 */
const ERROR_ENUM = { // serverSide.errorEnum.SYS0001
  /* eslint-disable */
  '500': t('serverSide.errorEnum[\'500\']'),
  /* eslint-enable */
  SYS0001: t('serverSide.errorEnum.SYS0001'),
  SYS0002: t('serverSide.errorEnum.SYS0002'),
  SYS0003: t('serverSide.errorEnum.SYS0003'),
  COM0001: t('serverSide.errorEnum.COM0001'),
  COM0002: t('serverSide.errorEnum.COM0002'),
  COM0003: t('serverSide.errorEnum.COM0003'),
  COM0004: t('serverSide.errorEnum.COM0004'),
  COM0005: t('serverSide.errorEnum.COM0005'),
  COM0006: t('serverSide.errorEnum.COM0006'),
  WJ0003: t('serverSide.errorEnum.WJ0003'),
  WJS0004: t('serverSide.errorEnum.WJS0004'),
  WJ0005: t('serverSide.errorEnum.WJ0005'),
  WJ0006: t('serverSide.errorEnum.WJ0006'),
  AT2010: t('serverSide.errorEnum.AT2010'),
  AT2011: t('serverSide.errorEnum.AT2011'),
  AT2012: t('serverSide.errorEnum.AT2012'),
  AT2013: t('serverSide.errorEnum.AT2013'),
  AT2014: t('serverSide.errorEnum.AT2014'),
  AT2015: t('serverSide.errorEnum.AT2015'),
  AT2016: t('serverSide.errorEnum.AT2016'),
  AT2021: t('serverSide.errorEnum.AT2021'),
  AT2022: t('serverSide.errorEnum.AT2022'),
  AT2023: t('serverSide.errorEnum.AT2023'),
  AT2024: t('serverSide.errorEnum.AT2024'),
  AT2025: t('serverSide.errorEnum.AT2025'),
  AT2026: t('serverSide.errorEnum.AT2026'),
  AT2027: t('serverSide.errorEnum.AT2027'),
  AT2028: t('serverSide.errorEnum.AT2028'),
  AT2029: t('serverSide.errorEnum.AT2029'),
  AT2050: t('serverSide.errorEnum.AT2050'),
  AT2051: t('serverSide.errorEnum.AT2051'),
  AT2052: t('serverSide.errorEnum.AT2052'),
  AT2053: t('serverSide.errorEnum.AT2053'),
  AT2054: t('serverSide.errorEnum.AT2054'),
  AT2055: t('serverSide.errorEnum.AT2055'),
  AT2056: t('serverSide.errorEnum.AT2056'),
  AT2057: t('serverSide.errorEnum.AT2057'),
  AT2058: t('serverSide.errorEnum.AT2058'),
  AT2059: t('serverSide.errorEnum.AT2059'),
  AT30001: t('serverSide.errorEnum.AT30001'),
  AT3002: t('serverSide.errorEnum.AT3002'),
  AT3003: t('serverSide.errorEnum.AT3003'),
  AT3004: t('serverSide.errorEnum.AT3004'),
  AT3005: t('serverSide.errorEnum.AT3005'),
  AT3006: t('serverSide.errorEnum.AT3006'),
  AT3007: t('serverSide.errorEnum.AT3007'),
  AT3008: t('serverSide.errorEnum.AT3008'),
  AT3009: t('serverSide.errorEnum.AT3009'),
  AT3010: t('serverSide.errorEnum.AT3010'),
  AT3011: t('serverSide.errorEnum.AT3011'),
  AT3012: t('serverSide.errorEnum.AT3012'),
  AT3013: t('serverSide.errorEnum.AT3013'),
  AT3014: t('serverSide.errorEnum.AT3014'),
  AT3015: t('serverSide.errorEnum.AT3015'),
  AT3016: t('serverSide.errorEnum.AT3016'),
  AT3017: t('serverSide.errorEnum.AT3017'),
  AT3018: t('serverSide.errorEnum.AT3018'),
  AT4001: t('serverSide.errorEnum.AT4001'),
  AT4002: t('serverSide.errorEnum.AT4002'),
  AT5001: t('serverSide.errorEnum.AT5001'),
  AT5002: t('serverSide.errorEnum.AT5002'),
  AT5003: t('serverSide.errorEnum.AT5003'),
  AT5004: t('serverSide.errorEnum.AT5004'),
  AT5005: t('serverSide.errorEnum.AT5005'),
  AT5006: t('serverSide.errorEnum.AT5006'),
  AT5007: t('serverSide.errorEnum.AT5007'),
  '000000': t('serverSide.errorEnum[\'000000\']'),
  GW0402: t('serverSide.errorEnum.GW0402'),
  GW0300: t('serverSide.errorEnum.GW0300'),
  GW0301: t('serverSide.errorEnum.GW0301'),
  GW0900: t('serverSide.errorEnum.GW0900'),
  GW0903: t('serverSide.errorEnum.GW0903'),
  GW0904: t('serverSide.errorEnum.GW0904'),
  GW0905: t('serverSide.errorEnum.GW0905'),
  GW0907: t('serverSide.errorEnum.GW0907'),
  GW0908: t('serverSide.errorEnum.GW0908'),
  GW0909: t('serverSide.errorEnum.GW0909'),
  GW0911: t('serverSide.errorEnum.GW0911'),
  GW0912: t('serverSide.errorEnum.GW0912'),
  GW0915: t('serverSide.errorEnum.GW0915'),
  GW0910: t('serverSide.errorEnum.GW0910'),
  GW0302: t('serverSide.errorEnum.GW0302'),
  GW0504: t('serverSide.errorEnum.GW0504'),
  GW0505: t('serverSide.errorEnum.GW0505'),
  GW0001: t('serverSide.errorEnum.GW0001'),
  GW0404: t('serverSide.errorEnum.GW0404'),
  GW0403: t('serverSide.errorEnum.GW0403'),
  GW0401: t('serverSide.errorEnum.GW0401'),
  GW0400: t('serverSide.errorEnum.GW0400'),
  GW0901: t('serverSide.errorEnum.GW0901'),
  GW0902: t('serverSide.errorEnum.GW0902'),
  GW0906: t('serverSide.errorEnum.GW0906'),
  GW0914: t('serverSide.errorEnum.GW0914'),
  GW0999: t('serverSide.errorEnum.GW0999'),
  GW0501: t('serverSide.errorEnum.GW0501'),
  GW0502: t('serverSide.errorEnum.GW0502'),
  GW0506: t('serverSide.errorEnum.GW0506'),
  GW0503: t('serverSide.errorEnum.GW0503'),
  GW0500: t('serverSide.errorEnum.GW0500'),
  AT5029: t('serverSide.errorEnum.AT5029'),
  AT5030: t('serverSide.errorEnum.AT5030'),
  AT5031: t('serverSide.errorEnum.AT5031')
}
function handleErrorCode(code, msg, showErrMsg) {
  console.log(`%c 当前输出关注`, 'color:#0ff', code, msg, showErrMsg)
  if (httpCode.identityPast.includes(code)) {
    vab.baseMessage(t('serverSide.customError.text_1'), 'error')

    cookieUtils.delCookie(tokenName)

    router.push({ path: '/login' })
  } else if (httpCode.unLogin.includes(code)) {
    vab.baseMessage(t('serverSide.customError.text_2'), 'error')
    router.push({ path: '/login' })
  } else if (httpCode.unauthorized.includes(code)) {
    router.push({ path: '/401' })
      .catch(() => {
      })
  } else if (httpCode.notFound.includes(code)) {
    router.push({ path: '/404' })
      .catch(() => {
      })
  } else {
    if (showErrMsg) {
      vab.baseMessage(isLocal ? msg || t('serverSide.customError.text_3', { code }) : ERROR_ENUM[code] || t('serverSide.customError.text_3', { code }), 'error')
    }
  }
}

var instance = http({
  baseURL: process.env.VUE_APP_BASE_URL,
  timeout: 30000,
}, parseRspBody, handleErrorCode)

export default instance
